import ticket from "./ticket";
import restaurant from './restaurant';
import hotel from './hotel';
import moment from 'moment';
import timezone from '../../data/timezone.js'
import store from '../index.js'

export default {
	state: {
		company_type: '',
		user: {},
    client_uid: "",
		token: {
			access: '',
			refresh: ''
		},
		forgot_password: '',
		language: 'en',
		merchant_timezone:{},
		currency: {},
		base_rate: {
			a: 1,
			b: 1,
			type: 'BASE'
		},
		merchant: {},
		merchant_load: true,
		active_route: '',
		meta_title: '',
    agent: {
    	code: '',
    	data: {}
    },
		payment_custom_token: '',
    activeDropdownId: null,
    showLoadingPage: false,
    module_config: {}
	},
	getters: {
		getCompanyType: state => state.company_type,
		token: state => state.token,
		getCurrentUser: state => state.user,
		getClientUid: state => state.client_uid,
		isLoggedIn: state => state.token.access == '' && state.token.refresh == '' ? false : true,
		isNotLogin(state) {
			let data = false
			if (state.token.access == '' && state.token.refresh == '') {
				data = true
			}
			return data
		},
		getForgotPassword: state => state.forgot_password,
		getCurrentLanguage: state => state.language,
		getMerchant: state => state.merchant,
		getActiveRoute: state => state.active_route,
		getCurrency: state => state.currency,
		getBaseRate: state => state.base_rate,
		isMarketRate: state => state.base_rate.type === 'MARKET',
		getMetaTitleTemplate: state => state.meta_title,
    getMerchantTimezone: state => state.merchant_timezone,
    getAgent: state => state.agent,
		getPaymentToken: state => state.payment_custom_token,
		getMerchantLoad: state => state.merchant_load,
    activeDropdownId: state => state.activeDropdownId,
    getLoadingPage: state => state.showLoadingPage,
    getModuleConfig: state => state.module_config
	},
	mutations: {
		setCompanyType(state,payload=''){
			state.company_type = payload
		},
		setModuleConfig(state,payload){
			let new_config = {}
			new_config[payload.key] = payload.data
			state.module_config = Object.assign({}, state.module_config, new_config)
		},
		setCurrency(state,payload){
			state.currency = payload
		},

    setClientUid(state,payload){
			state.client_uid = payload
		},

		setBaseRate(state,payload){
			state.base_rate = payload
		},

		setUserMutation(state, payload) {
			state.user = payload;
		},

		setTokenMutation(state, payload) {
			state.token = {
				access: '',
				refresh: ''
			};
			state.token = payload;
		},

		setForgetPasswordMutation(state, payload) {
			state.forgot_password = payload
		},

		setLanguageMutation(state, payload) {
			state.language = payload
		},

		setMerchantMutation(state, payload) {
			if (payload.type == 'reset') {
				state.merchant = {}
			} else if (payload.type == 'update') {
				state.merchant = payload.data
			} else {
				if(payload.data.merchant_type == 'hotel'){
					hotel.state.be_filter = {
						date: {
							check_in: new Date(),
							check_out: moment().add(payload.data.search_room_filter_default_total_night,'d').toDate(),
						},
						guest: {
							adult: payload.data.search_room_filter_default_total_adult,
							child: 0,
							infant: 0,
						},
						promo_code: '',
					}
					hotel.state.be_price= [0,0]
			    hotel.state.be_sort_by= 'room_type'
				}
				state.merchant = payload.data
			}
		},

		setMerchantLoad(state, payload){
			state.merchant_load = payload
		},

		setActiveRoute(state,payload){
			state.active_route = payload		
		},

		setMetaTitleTemplate(state,payload){
			state.meta_title = payload
		},

    setMerchantTimezone(state,payload){
    	let tz_index = timezone.findIndex(x=>x.name==payload)
    	if(payload != 'local' && tz_index != -1){
    		state.merchant_timezone = timezone[tz_index]
    	}else{
    		let local_tz = moment().format("Z")
    		let local_tz_index = timezone.findIndex(x=>x.offset==local_tz)
    		if(local_tz_index != -1){
    			state.merchant_timezone = timezone[local_tz_index]
    		}else{
    			state.merchant_timezone = timezone.find(x=>x.name=='Asia/Makassar')
    		}
    	}
    },

    setAgent(state,payload){
    	state.agent
    	for (let param of payload){
				state.agent[param.key] = param.value
			}
    },

		setPaymentToken(state,payload){
			state.payment_custom_token = payload
		},

		resetAllDataGeneral(state,payload='without_user'){
			state.forgot_password = ''
			state.language = 'en'
			state.merchant_timezone ={}
			state.currency = {}
			state.base_rate = {
				a: 1,
				b: 1,
				type: 'BASE'
			}
			state.merchant = {}
			state.active_route = ''
			state.meta_title = ''
			state.agent = {
				code: '',
				data: {}
			}
			state.payment_custom_token = ''
			if(payload == 'with_user'){
				state.user= {},
				state.token= {
					access: '',
					refresh: ''
				}
			}
		},

    setActiveDropdown(state, id) {
      state.activeDropdownId = id
    },

    clearActiveDropdown(state) {
      state.activeDropdownId = null
    },

    setLoadingPage(state, payload) {
      state.showLoadingPage = payload 
    }
	},
	actions: {
		setUser({ commit }, payload) {
			commit('setUserMutation', payload)
		},
		setForgotPassword({ commit }, payload) {
			commit("setForgetPasswordMutation", payload)
		},
		logout({ commit,state }) {
			if(state.merchant.merchant_type == 'hotel' && store.getters.isReservationActive && store.getters.isCurrentUserSameWithRsvUser){
				store.commit("setReservationActive",'reset')
			}
			commit('setUserMutation', {})
			commit('setTokenMutation', { access: '', refresh: '' })
			if(state.company_type == 'AFFILIATE'){
				commit("setAgent",[{
					key: 'code',
					value: ''
				},
				{
					key: 'data',
					value: {}
				}])
			}
		},
		setToken({ commit }, payload) {
			commit('setTokenMutation', payload)
		},
		setLanguage({ commit }, payload) {
			commit('setLanguageMutation', payload)
		},
		setMerchant({ commit}, payload) {
			commit('setMerchantMutation', payload, { root: true })
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/general.js